import { render, staticRenderFns } from "./RevsTab.vue?vue&type=template&id=7ae782e2&scoped=true"
import script from "./RevsTab.vue?vue&type=script&lang=js"
export * from "./RevsTab.vue?vue&type=script&lang=js"
import style0 from "./RevsTab.vue?vue&type=style&index=0&id=7ae782e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae782e2",
  null
  
)

export default component.exports